export const SUBMIT_AREAS_ACTION_REQUESTED = "SUBMIT_AREAS_ACTION_REQUESTED";
export const SUBMIT_AREAS_ACTION_DISPATCHER =
  "SUBMIT_AREAS_ACTION_DISPATCHER";
export const SUBMIT_AREAS_ERROR_DISPATCHER = "SUBMIT_AREAS_ERROR_DISPATCHER";
export const AREAS_LOADING = "AREAS_LOADING";

//Action Creator
export const submitAreasAction = (data) => ({
  type: SUBMIT_AREAS_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitAreasActionDispatcher = (data) => ({
  type: SUBMIT_AREAS_ACTION_DISPATCHER,
  payload: data,
});

export const submitAreasErrorDispatcher = (data) => ({
  type: SUBMIT_AREAS_ERROR_DISPATCHER,
  payload: data,
});

export const areasLoading = (loading) => ({
  type: AREAS_LOADING,
  payload: loading,
});
